import { useMemo } from "react"

import { useTransportQuery } from "@/transport"

const METADATA_KEYS_CACHE_TIME = 15 * 60 * 1000
const METADATA_KEYS_STALE_TIME = 5 * 60 * 1000

export function useMetricMetadataKeysTransport() {
  return useTransportQuery({
    operation: "getMetricMetadataKeys",
    request: {},
    options: {
      gcTime: METADATA_KEYS_CACHE_TIME,
      staleTime: METADATA_KEYS_STALE_TIME,
      select: (response) => response.keys ?? [],
    },
  })
}

export function useMetricMetadataValuesTransport({
  key,
  search,
  enabled = true,
}: {
  key: string
  search?: string
  enabled?: boolean
}) {
  const request = useMemo(
    () => ({
      key,
      search: search || undefined,
    }),
    [key, search],
  )

  return useTransportQuery({
    operation: "getMetricMetadataValues",
    request,
    options: {
      enabled: enabled && Boolean(key),
      gcTime: METADATA_KEYS_CACHE_TIME,
      staleTime: METADATA_KEYS_STALE_TIME,
      select: (response) => response.values ?? [],
    },
  })
}
